import FaqList from "../../static-data/FaqList";

export function getFaqList() {
  return FaqList;
}